<template>
  <div class='main'>
    <div class="dateSelect">
      <el-date-picker
        v-model="pickDate"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        @change="GetDataList"
      >
      </el-date-picker>
    </div>
    <Table
      :tableData="tableData"
      :pageindex="params.pageindex"
      :pagesize="params.pagesize"
      :total="total"
      :labelData="labelData"
      :propertyData="propertyData"
      @GetDataList="GetDataList"
      @currentpage="getcurrentpage"
    ></Table>
  </div>
</template>
<script>
import Table from '../../components/table'
import Api from '../../api/index'
import log from '../../api/system/sysLog'

export default {
  data () {
    return {
      labelData: ['编号', '日志类型(0操作 1异常)', '创建人', '模块名', 'IP地址', '创建时间', '日志内容'],
      propertyData: ['LogId', 'LogType', 'UserAccount', 'SysModule', 'IP', 'CreateDate', 'LogContent'],
      tableData: [],
      total: 1,
      pickDate: '',
      params: {
        pageindex: 1,
        pagesize: 14,
        startdate: '',
        enddate: ''
      }
    }
  },
  created () {
    this.GetDataList()
  },
  components: {
    Table,
  },
  methods: {
    getcurrentpage (val) {
      this.params.pageindex = val
    },
    //获取日志列表
    async GetDataList () {
      this.params.startdate = this.pickDate[0]
      this.params.enddate = this.pickDate[1]
      const res = await Api.log.GetLogList(this.params)
      if (res.success != true) return this.$message.info(res.msg)
      this.tableData = res.rows
      this.total = res.total
    }

  }
}
</script>
<style lang='less' scoped>
.main {
  width: 100%;
  height: 100%;
  background: #fff;
  .dateSelect {
    padding: 20px;
    /deep/.el-range-separator {
      padding: 0;
    }
  }
}
</style>